// Import styles of packages that you"ve installed.
// All packages except `@mantine/hooks` require styles imports
import "../common/mantine.css"
import "@mantine/core/styles.css";
import "@mantine/core/styles/global.css";
import "@mantine/dates/styles.css";
import "@mantine/tiptap/styles.css";
import "@mantine/core/styles.css";
import "@mantine/dropzone/styles.css";
import '@mantine/notifications/styles.css';
import "../common/common.css"

// ⚠️ Import BIOS branded fonts early to ensure they're available for first render
import "../common/themes/bios/fonts.css";

import React from "react";
import {
    MantineProvider,
    MantineThemeOverride,
} from "@mantine/core";
import {Notifications} from "@mantine/notifications"
import "@mantine/tiptap/styles.css";
import {ModalsProvider} from "@mantine/modals";
import {theme as biosTheme} from "../common/themes/bios/BiosTheme"


type MantineWrapperProps = {
    children?: React.ReactNode,
    theme?: MantineThemeOverride
};
export const NeurotuneProvider: React.FC<MantineWrapperProps> = ({children, theme = biosTheme}) => {
    return (
        <MantineProvider theme={theme}>
            <ModalsProvider>
                <Notifications zIndex={15000} />
                {children}
            </ModalsProvider>
        </MantineProvider>
    );
};